import React, { useState } from 'react';
import tailTraceIcon from '../assets/tailTraceIconT.png';
import './contact.css';

const Contact = () => {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    reason: '',
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch('https://formspree.io/f/xgvyevew', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: formData.name,
        email: formData.email,
        message: formData.message,
        reason: formData.reason,
      }),
    });

    if (response.ok) {
      setSubmitted(true);
      setFormData({ name: '', email: '', message: '', reason: '' });
      setTimeout(() => setSubmitted(false), 3000);
    } else {
      console.error(await response.json());
      alert('Submission failed. Please check your form and try again.');
    }
  } catch (error) {
    alert('Network error. Please try again.');
  }
};


  return (
    <div className="contactContainer">
      <h1 className="contactTitle">Contact Us</h1>

      <form className="contactForm" onSubmit={handleSubmit}>
        <input
          name="name"
          type="text"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          name="email"
          type="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <select
          name="reason"
          value={formData.reason}
          onChange={handleChange}
          required
        >
          <option value="" disabled>Select a reason</option>
          <option value="feedback">Feedback</option>
          <option value="bug">Bug Report</option>
          <option value="general">General Inquiry</option>
          <option value="partnership">Partnership Opportunity</option>
        </select>
        <textarea
          name="message"
          rows="5"
          placeholder="Your Message"
          value={formData.message}
          onChange={handleChange}
          required
        />
        <button type="submit">Send Message</button>
      </form>
      <form
        action="https://formspree.io/f/xkgzodrz"
        method="POST"
        className="subscriptionForm"
      >
        <label htmlFor="email" className="subscriptionLabel">
          📬
          <p>
            Be the First to Know When TailTrace Launches
          </p> 
        </label>
        <input
          type="email"
          name="email"
          id="email"
          placeholder="Enter your email"
          required
          className="subscriptionInput"
        />
        <input type="hidden" name="_subject" value="New TailTrace Subscriber!" />
        <button type="submit" className="subscriptionButton">Notify Me</button>
      </form>

      <input type="hidden" name="_subject" value="New TailTrace Subscriber!" />


      {submitted && (
        <>
          <img
            src={tailTraceIcon}
            alt="TailTrace driving logo"
            className="carAnimation"
          />
          <div className="confirmationPopup">Message sent successfully!</div>
        </>
      )}
    </div>
  );
};

export default Contact;
